module.exports = __webpack_public_path__ + "static/logo-zbj.976070b6.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/logo-zbj.png
// module id = 1029
// module chunks = 2